@if (qb.loading$ | async) {
  <qb-loading style="position: fixed; width: 100%; z-index: 3000; pointer-events: none"></qb-loading>
}

<div id="loading-overlay" [class.active]="qb.loading$ | async"></div>
<!-- private -->
@if (showMaster) {
  <qb-header (toggleSideNav)="sidenav.toggle()"></qb-header>
  <mat-sidenav-container class="main-container">
    <mat-sidenav #sidenav mode="over" class="sidenav">
      <ul class="side-nav-list">
        @for (route of userRoutes | async; track $index) {
          <li>
            <a class="nav-link" [routerLink]="route.route" (click)="sidenav.toggle()">
              {{ route.name }}
            </a>
          </li>
        }
      </ul>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="sm:px-5 sm:pt-8">
        <div class="wrapper">
          <router-outlet></router-outlet>
        </div>
        <qb-footer></qb-footer>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
} @else {
  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
  @if (!landing) {
    <div>
      <qb-footer></qb-footer>
    </div>
  }
}

<!-- public -->

<!-- notifications -->
<qb-toast></qb-toast>
